function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M185.389,494.93c-1.859-1.86-4.439-2.93-7.07-2.93c-2.63,0-5.21,1.07-7.069,2.93c-1.86,1.86-2.931,4.44-2.931,7.07 s1.07,5.21,2.931,7.07c1.859,1.86,4.439,2.93,7.069,2.93c2.631,0,5.211-1.07,7.07-2.93c1.86-1.86,2.93-4.44,2.93-7.07 S187.25,496.79,185.389,494.93z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M354.922,415.17c-5.522,0-10,4.477-10,10c0,18.608-15.139,33.748-33.747,33.748c-5.522,0-10,4.477-10,10s4.478,10,10,10 c29.636,0,53.747-24.111,53.747-53.748C364.922,419.647,360.444,415.17,354.922,415.17z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M428,0c-46.317,0-84,37.682-84,84v120c0,42.932,32.382,78.422,74,83.384V375h-35.993 c-15.748-22.169-41.629-36.661-70.832-36.661c-7.646,0-15.064,0.998-22.133,2.862L255.688,256h40.667 c2.349,0,4.415,1.5,5.142,3.735c0.741,2.279-0.163,4.016-0.768,4.848c-0.604,0.833-1.977,2.229-4.374,2.229h-10.222 c-5.522,0-10,4.477-10,10s4.478,10,10,10h10.222c8.228,0,15.72-3.818,20.556-10.475c4.835-6.656,6.149-14.962,3.606-22.785 C317.104,243.054,307.395,236,296.354,236h-55.321c-3.306,0-6.396,1.633-8.26,4.363c-1.864,2.73-2.257,6.205-1.052,9.282 l18.781,47.974h-83.107l-7.526-17.215l-2.843-7.245c-1.502-3.829-5.195-6.347-9.309-6.347h-43.482 c-8.406,0-16.253,4.146-20.988,11.092c-4.736,6.946-5.73,15.765-2.659,23.591c3.844,9.794,13.126,16.124,23.647,16.124h33.142 l-16.085,27.86c-10.571-4.589-22.224-7.14-34.463-7.14C38.952,338.34,0,377.292,0,425.17c0,26.85,12.251,50.89,31.456,66.83H10 c-5.522,0-10,4.477-10,10s4.478,10,10,10h76.83c44.496,0,81.276-33.645,86.251-76.83h39.162c3.374,0,6.521-1.702,8.368-4.525 c1.848-2.824,2.146-6.389,0.795-9.48L176.139,317.62h82.193l12.095,30.895c-27.395,14.621-46.083,43.495-46.083,76.655 c0,26.85,12.251,50.89,31.456,66.83h-35.48c-5.522,0-10,4.477-10,10s4.478,10,10,10h90.854c47.878,0,86.83-38.952,86.83-86.83 c0-10.604-1.914-20.768-5.409-30.169h71.737c5.522,0,10-4.477,10-10s-4.478-10-10-10H438v-87.616 c41.618-4.962,74-40.452,74-83.384V84C512,37.682,474.317,0,428,0z M104.235,297.62c-2.238,0-4.212-1.347-5.03-3.43 c-0.907-2.313-0.035-4.137,0.566-5.018c0.601-0.881,1.979-2.359,4.464-2.359h36.664l4.241,10.807H104.235z M86.83,492 C49.979,492,20,462.02,20,425.17s29.979-66.83,66.83-66.83c8.598,0,16.813,1.65,24.37,4.621L78.17,420.17 c-1.786,3.094-1.786,6.906,0,10s5.088,5,8.66,5h32.235c-4.272,13.741-17.107,23.748-32.235,23.748c-5.522,0-10,4.477-10,10 s4.478,10,10,10c26.219,0,48.099-18.875,52.801-43.748h13.279C148.069,467.293,120.282,492,86.83,492z M104.15,415.17 l24.357-42.186c12.849,10.282,21.841,25.19,24.403,42.186H104.15z M196.957,415.17h-23.876 c-2.808-24.372-15.742-45.705-34.482-59.667l18.366-31.811L196.957,415.17z M311.175,492c-36.851,0-66.831-29.98-66.831-66.83 c0-24.693,13.473-46.285,33.443-57.855l24.076,61.501c1.544,3.945,5.318,6.357,9.314,6.357c1.212,0,2.445-0.222,3.643-0.691 c5.143-2.014,7.68-7.814,5.666-12.958l-24.083-61.519c4.756-1.078,9.695-1.666,14.772-1.666c36.851,0,66.83,29.98,66.83,66.83 S348.025,492,311.175,492z M492,204c0,31.888-23.444,58.398-54,63.214V225.63l26.647-28.449 c3.775-4.031,3.568-10.359-0.463-14.134c-4.029-3.775-10.358-3.568-14.135,0.462L438,196.372V164.2l26.647-28.449 c3.775-4.031,3.568-10.359-0.463-14.135c-4.029-3.775-10.358-3.568-14.135,0.462L438,134.943V117.5c0-5.523-4.478-10-10-10 c-5.522,0-10,4.477-10,10v45.028l-10.295-10.991c-3.776-4.031-10.104-4.237-14.135-0.462c-4.031,3.775-4.238,10.104-0.463,14.134 L418,191.785v75.428c-30.556-4.816-54-31.326-54-63.214V84c0-35.29,28.71-64,64-64c35.29,0,64,28.71,64,64V204z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M502,375h-0.131c-5.522,0-10,4.477-10,10s4.478,10,10,10H502c5.522,0,10-4.477,10-10S507.522,375,502,375z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M238.833,138.667h-16.592c3.937-7.998,6.055-16.869,6.055-25.935c0-32.385-26.347-58.731-58.731-58.731 c-24.116,0-45.227,14.707-54.17,36.036c-5.736-2.759-12.076-4.24-18.562-4.24C73.215,85.796,54,105.011,54,128.629 c0,9.549,3.083,18.59,8.914,26.147c1.894,2.453,4.817,3.891,7.917,3.891h168.002c5.522,0,10-4.477,10-10 S244.355,138.667,238.833,138.667z M198.321,138.666H76.318C74.793,135.568,74,132.164,74,128.629 c0-12.59,10.243-22.833,22.833-22.833c6.453,0,12.637,2.753,16.965,7.554c2.621,2.907,6.695,4.018,10.429,2.842 c3.733-1.175,6.438-4.419,6.922-8.303C133.553,88.569,150.068,74,169.564,74c21.356,0,38.731,17.375,38.731,38.731 C208.295,122.321,204.698,131.585,198.321,138.666z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      "enableBackground": "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

export default __webpack_public_path__ + "static/media/bike.0c155670.svg";
export { SvgComponent as ReactComponent };